import { Component, Input, OnInit } from '@angular/core';
import { CheckPersonRulesMatrixModel, GetPersonModel, PersonModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-change-player-panel',
    templateUrl: './change-player-panel.component.html',
    styleUrls: ['./change-player-panel.component.scss'],
    standalone: false
})
export class ChangePlayerPanelComponent implements OnInit {
    @Input() player: GetPersonModel;
    @Input() changedPlayer: PersonModel;
    @Input() playerRules: CheckPersonRulesMatrixModel;
    @Input() categoryName: string;
    constructor() { }

    ngOnInit(): void { }

    public get anyRulesExceeded(): boolean {
        return (
            this.playerRules &&
            (this.playerRules.maxBookingsPerDayExceeded ||
                this.playerRules.maxMinutesPerDayExceeded ||
                this.playerRules.courtBookingNotAllowed)
        );
    }
}
